import { ReduxClient } from '@sm360/widget-commons-general';

import { setConfigs } from 'commons-configs/actions/ConfigsAction.js';
import configReducer from 'commons-configs/reducers/configReducer.js';

class EnvironmentConfigsService {
    /**
     * Initialize the configs in the Redux store. Inject reducers and save configs
     * @param {Object} configs The configs to save in the Redux store
     */
    static init(configs) {
        const reduxStore = ReduxClient.getOrCreate();
        const state = reduxStore.getState();

        if (state && state.configs) {
            return;
        }

        ReduxClient.addReducers({ configs: configReducer });
        reduxStore.dispatch(setConfigs(configs));
    }

    /**
     * Returns the required config
     * @requires `Redux` must be initialized
     * @requires `EnvironmentConfigsService.get` must have been called first
     * @param {String} key Must have the following format: `parent.child.grandchild`
     * @throws When requirement aren't specified
     * @returns {String} the required config
     */
    static get(key) {
        if (!key) {
            throw new Error(
                'The [key] param is required. It must be a string with the following format: `parent.child.grandchild`'
            );
        }

        const reduxStore = ReduxClient.getOrCreate();
        const reduxState = reduxStore.getState();
        if (!reduxState) {
            throw new Error('Redux Store seems empty. Redux needs to be initialized first');
        }

        const { configs } = reduxState;
        if (!configs) {
            throw new Error(
                'This configs are missing. You need to call `EnvironmentConfigsService.init` first. Be careful of React lifecycle.'
            );
        }

        return configs.getIn(key.split('.'));
    }
}

export default EnvironmentConfigsService;
